import type { ReactElement } from "react";
import { Checkmark } from "../../../../../../../../../../generated/images";
import { Icon } from "@smartsuite/react-ui/lib";
import {
  IconWrapper,
  DropdownItem,
  DropdownSelected,
  DropdownText,
} from "../style";
import { translateIfPresent } from "../../../../../../../../../locales/i18n";
import { TextColorNames } from "@smartsuite/types";

export const getIcon = (iconName: string): ReactElement => {
  return (
    <IconWrapper>
      <Icon name={iconName} size="S" color={TextColorNames.tertiary} />
    </IconWrapper>
  );
};

export const renderOption = (
  option: Record<string, string>,
  bodyType: string,
  onSelectedOptionChange: (value: string, data: boolean) => void,
  selected = false,
  firstRender = false,
): ReactElement => {
  return (
    <DropdownItem
      selected={selected}
      onClick={() =>
        firstRender && onSelectedOptionChange(option.value, firstRender)
      }
    >
      <span>
        {getIcon(option.iconName)}
        <DropdownText>
          {translateIfPresent(`caption.${option.label}`, option.label)}
        </DropdownText>
      </span>
      {!selected && option.value === bodyType && (
        <DropdownSelected>
          <Checkmark />
        </DropdownSelected>
      )}
    </DropdownItem>
  );
};
